type CompanyFollowGtmContentArgs = {
  companyId: number;
  companyName: string;
  location: string;
};

export const buildCompanyFollowGtmContent = ({
  companyId,
  companyName,
  location,
}: CompanyFollowGtmContentArgs): string =>
  JSON.stringify({
    company_id: companyId,
    company_name: companyName,
    location,
  });
